import { S } from './TileTitleWithPrice';
import { useStaticContext } from '../../../../utilities/context/static/StaticContext';
import { LowestPriceDisplay } from '../../../../utilities/graphql/codegen';

type TileTitleOriginalPriceProps = {
  originalPriceCopy: string | undefined;
  discountedPrice?: string | null;
  initialPrice?: string | null;
  discountedColor?: string;
};

export const TileTitleOriginalPrice = ({
  originalPriceCopy,
  discountedPrice,
  initialPrice,
  discountedColor,
}: TileTitleOriginalPriceProps) => {
  const {
    configuration: { lowestPriceDisplay },
  } = useStaticContext();

  const isOnlyLowestPrice = lowestPriceDisplay === LowestPriceDisplay.OnlyLowestPrice;

  return (
    <S.PriceTitleOriginal data-testid="product-tile-original-price">
      {!isOnlyLowestPrice && initialPrice && discountedPrice !== initialPrice && (
        <S.PriceLowest30Days>
          {originalPriceCopy} {initialPrice}
        </S.PriceLowest30Days>
      )}
      <span>
        {discountedPrice && discountedPrice !== initialPrice ? (
          <S.DiscountedPrice $color={discountedColor} data-testid="product-tile-price">
            {discountedPrice}
          </S.DiscountedPrice>
        ) : (
          <S.InitialPrice data-testid="product-tile-price">{initialPrice}</S.InitialPrice>
        )}
      </span>
    </S.PriceTitleOriginal>
  );
};
